const Home = () => import('@/views/Home.vue'/*webpackChunkName: 'home.chunk' */)
const About = () => import('@/views/About.vue'/*webpackChunkName: 'aboute.chunk' */)
// const Evaluate = () => import('@/views/Evaluate')
// const Eval = () => import('@/views/public/Eval')
// const Login = () => import('@/views/Login')
import Evaluate from '@/views/Evaluate'
import Eval from '@/views/public/Eval'
import Login from "@/views/Login"
import QRScan from "./views/QRScan"
import OtherMenu from "./views/OtherMenu"
import WorkFlow from "@/views/WorkFlow.vue";
import RivalSubMenu from "./views/RivalSubMenu";
import EagleSubMenu from "./views/EagleSubMenu";
import DisplaySubMenu from "@/views/DisplaySubMenu.vue";
import DisplaySubMenu2 from "@/views/DisplaySubMenu2.vue";
export default [
    {path: '/', component: Home,name:'home'},
    {path: '/login', component: Login,name:'login'},
    {path: '/other_menu', component: OtherMenu,name:'OtherMenu'},
    {path: '/about', component: About, name: 'about'},
    {path: '/qrscan', component: QRScan, name: 'qrscan',props:true},
    {path: '/evaluate', component: Evaluate,name:'evaluate',props: true},
    {path: '/eval', component: Eval,name:'eval',props: true},
    {path: '/WorkFlow', component: WorkFlow,name:'WorkFlow',props: true},
    {path: '/RivalSubMenu', component: RivalSubMenu,name:'RivalSubMenu',props: true},
    {path: '/EagleSubMenu', component: EagleSubMenu,name:'EagleSubMenu',props: true},
    {path: '/DisplaySubMenu', component: DisplaySubMenu,name:'DisplaySubMenu',props: true},
    {path: '/DisplaySubMenu2', component: DisplaySubMenu2,name:'DisplaySubMenu2',props: true},
]
